import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
    //   cacheTime: 1 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});
